/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'
import DropdownTreeSelect from 'react-dropdown-tree-select';
import 'react-dropdown-tree-select-sco/dist/styles.css'

class LinuxModeBits extends React.Component
{
  constructor(props)
  {
    super();

    var fileModeBits =       
    [
      {label: "user execute", value: 64, index: 0, checked: false},
      {label: "group read", value: 32, index: 1, checked: false},
      {label: "group write", value: 16, index: 2, checked: false},
      {label: "group execute", value: 8, index: 3, checked: false},
      {label: "other read", value: 4, index: 4, checked: false},
      {label: "other write", value: 2, index: 5, checked: false},
      {label: "other execute", value: 1, index: 6, checked: false}
    ];
  
    var subdirModeBits =       
    [
      {label: "group read", value: 32, index: 0, checked: false},
      {label: "group write", value: 16, index: 1, checked: false},
      {label: "group execute", value: 8, index: 2, checked: false},
      {label: "other read", value: 4, index: 3, checked: false},
      {label: "other write", value: 2, index: 4, checked: false},
      {label: "other execute", value: 1, index: 5, checked: false}
    ];

    this.state = 
    {
      modeBitsData: props.fileOrSubdir === 'file' ? fileModeBits : subdirModeBits
    }

    this.setModeBits = this.setModeBits.bind(this);
  }

  render()
  {
    return(
      <div><DropdownTreeSelect data={this.state.modeBitsData} onChange={this.setModeBits} classname="bootstrap-demo"/></div>
    );
  };

  setModeBits(currentNode, selectedNodes)
  {
    var modeValue = 0;

    for (let x = 0; x < selectedNodes.length; x++)
    {
      modeValue += selectedNodes[x].value;
    }

    let modeBitsData = this.state.modeBitsData;
    modeBitsData[currentNode.index].checked = currentNode.checked;
    this.setState({modeBitsData});
    this.props.setValue(modeValue);
  }
}

export default LinuxModeBits